import {
    SHOW_DIRECTIONS,
    FETCH_DIRECTIONS, RECEIVE_DIRECTIONS,
    DIRECTIONS_ERROR, RESET_DIRECTIONS
} from './../actions/DirectionsAction';

const defaultState = {
    show    : false,
    place   : null,
    result  : null,
    status  : null,
    fetching: false,
    fetched : false
};

const directions = (state = defaultState, action) => {
    let newState;
    switch(action.type) {
        case SHOW_DIRECTIONS:
            newState = {...state,
                show : true,
                place: action.place
            };
            break;
        case FETCH_DIRECTIONS:
            newState = {...state,
                fetching: true
            };
            break;
        case RECEIVE_DIRECTIONS:
            newState = {...state,
                result  : action.directions,
                status  : action.status,
                fetching: false,
                fetched : true
            };
            break;
        case DIRECTIONS_ERROR:
            newState = {...state,
                result  : false,
                status  : action.status,
                fetching: false,
                fetched : false
            };
            break;
        case RESET_DIRECTIONS:
            newState = defaultState;
            break;
        default:
            newState = state;
            break;
    }

    return newState;
};

export default directions;



// WEBPACK FOOTER //
// ./src/reducers/DirectionsReducer.js